import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  margin-top: 148px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--blue6, #21105d);
  margin-bottom: 17px;
  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;
  }
`

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 30px 0;

  .slick-list {
    margin: 0 -8px;
    padding: 20px 0 !important;
  }

  .slick-slide {
    padding: 0 8px;
    box-sizing: border-box;
  }
`

export const Item = styled.div`
  width: 100%;
  max-width: 235px;
  margin: 0 auto;
  height: 419px;
  background: #d9ddf0;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(33, 16, 93, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:hover .hover-overlay {
    opacity: 1;
    pointer-events: auto;
  }

  @media (max-width: 1200px) {
    height: 370px;
  }
  @media (max-width: 900px) {
    height: 300px;
  }
  @media (max-width: 600px) {
    height: 220px;
  }
`

export const ItemTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  color: var(--blue6, #21105d);
  text-align: center;
  margin-top: 32px;
  margin-bottom: 0;
  padding: 0 8px;
  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const ItemImageWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 83px;
  transform: translateX(-50%);
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    position: static;
    left: auto;
    bottom: auto;
    transform: none;
    margin-top: 16px;
    margin-bottom: 0;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
`

export const HoverOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  border-radius: 16px;
  z-index: 10;
`

export const HoverButton = styled.button`
  background: var(--blue6, #21105d);
  color: #fff;
  font-size: 18px;
  padding: 15px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background 0.2s;

  &:hover {
    background: #3a228c;
  }

  @media (max-width: 900px) {
    font-size: 14px;
  }

  @media (max-width: 600px) {
    font-size: 12px;
  }
`
